import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import { OrganizationInDto } from 'shared/domain/organization/types/dto';
import { broadcastUploadedOrganizationError } from 'serviceWorker/broadcasts/organization/error';
import {
  broadcastCreatedOrganization,
  broadcastUpdatedOrganization,
} from 'serviceWorker/broadcasts/organization/one';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { neverReached } from 'shared/utils/neverReached';

export function broadcastOrganizationResponse(
  request: HttpRequestEntity,
  response: OrganizationInDto | { error: unknown }
): void {
  const { uniqueId } = request.data;
  if ('error' in response) {
    return broadcastUploadedOrganizationError(
      response.error,
      chooseErrorMessage(response.error),
      uniqueId
    );
  }
  switch (request.method) {
    case 'POST':
    case 'GET':
      // Never rejects: a failure is broadcast as `failUploadedEntity` with the `uniqueId`.
      return void broadcastCreatedOrganization(response, uniqueId);
    case 'PUT':
      return void broadcastUpdatedOrganization(response, uniqueId);
    case 'DELETE':
      return broadcastUploadedOrganizationError(
        new Error('DELETE method not supported for organization'),
        null,
        uniqueId
      );
    default:
      neverReached(request.method);
  }
}

/** Carries the change's `uniqueId`, so the page's command rejects with this error. */
export function broadcastOrganizationError(
  request: HttpRequestEntity,
  error: unknown,
  uniqueId?: string
): void {
  broadcastUploadedOrganizationError(
    error,
    chooseErrorMessage(error),
    uniqueId ?? request.data?.uniqueId
  );
}
